import type {Concept, LinkTargetMainEntityType} from 'domainTypes';
import {LinkTargetMainEntityTypes} from 'domainTypes';

export const isLinkTargetMainEntityType = (
  type: Concept | undefined,
): type is LinkTargetMainEntityType => {
  return LinkTargetMainEntityTypes.includes(type as LinkTargetMainEntityType);
};
